// Vue
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getCurrentInstance } from 'vue';

// common
import i18n from '@/common/i18n';

// Repository
import CompanyRepository from '@/repositories/companyRepository';

// commonProject
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';

// Model
import { Dictionary } from '@/models/utils/dictionary';

import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useCommonStore = defineStore({
    id: 'common',
    state: () => ({
        language: ref('ja'),
        languageList: [],
        from: '',
        companyInfo: {},
        API_URL: '',
        Dictionary,
        isSsoLoggedin: false, // SSOログインを行った場合。
    }),
    getters: {
        getLanguage() {
            return this.language;
        },
        getConvertDictionary: () => (type, key) => {
            const dictionary = Dictionary[type];
            return dictionary ? dictionary[key] || '' : '';
        },
        /**
         * 格納されている画面遷移元情報を返却する。
         * @param なし
         * @returns {string} from 画面遷移元の情報。
         */
        getFrom() {
            return this.from;
        },
    },
    actions: {
        resetAllStorage() {
            localStorage.clear();
            sessionStorage.clear();
        },
        resetSessionStorage() {
            sessionStorage.clear();
        },
        resetLocalStorage() {
            localStorage.clear();
        },
        /**
         * APIのドメイン部分を取得
         */
        async getDomain() {
            const app = getCurrentInstance();
            this.API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;
        },
        setLanguage(value) {
            this.language = value;
        },
        /**
         * 画面遷移元の情報を設定する。
         * 例：本来はホーム画面から一覧画面を経由して詳細画面を表示する遷移が、ホーム画面から直に詳細画面を表示したい場合は、「home」などホーム画面からの遷移であることを示す文字列を入力する。
         * @param {string} from
         * @returns なし
         */
        setFrom(from) {
            this.from = from;
        },
        reset() {
            this.from = '';
            this.isSsoLoggedin = false; // SSOログインを行った場合。
        },
        /**
         * 企業情報取得API
         * @param {*} req
         * @returns response
         */
        async getCompanyAction(req) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const companyRepository = new CompanyRepository();
            try {
                const response = await companyRepository.getCompanyApi(req, null, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.companyInfo = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        //ローカルストレージに保存
        storage: localStorage,
    },
});
